import Separator from 'components/common/separator';
import { Input } from 'components/elements';
import Text from 'components/elements/text';
import { CardSection } from 'legacy-modules/styles';
import useTranslation from 'next-translate/useTranslation';
import * as React from 'react';
import { useFormContext, useWatch } from 'react-hook-form';
import { StyleObject } from 'styletron-standard';

import ActivityPurchaseAddOnsTable from './addons-table';
import ActivityPurchaseItem from './detail-table';
import ActivityPurchaseGuestTable from './guest-table';
import { ScheduleCardHeader } from '../../../style';

export default function ActivityGuestCard() {
  const { t } = useTranslation();
  const { control } = useFormContext();
  const activityPurchases = useWatch({
    control,
    name: 'approvalable.activityPurchases',
  });

  return (
    <>
      {activityPurchases.map((activityPurchase, idx) => {
        return (
          <React.Fragment key={activityPurchase.id}>
            <CardSection>
              <ScheduleCardHeader $style={style}>
                <Text variant="HeadingXSmall">
                  {t('common:other_purchase_detail')} {idx + 1}
                </Text>
                <Input
                  type="check-box"
                  name={`approvalable.activityPurchases.${idx}.isGroupedPrice`}
                  label={t('ticketSales:grouped_price')}
                  noMargin
                />
              </ScheduleCardHeader>
              <Separator gap={24} />
              <ActivityPurchaseGuestTable parentIndex={idx} />
              <Separator gap={24} />
              <ActivityPurchaseItem parentIndex={idx} />
              <Separator gap={24} />
              <Text variant="ParagraphSmall">{t('ticketOrders:add_ons')}</Text>
              <ActivityPurchaseAddOnsTable parentIndex={idx} />
            </CardSection>
            <Separator gap={24} />
          </React.Fragment>
        );
      })}
    </>
  );
}

const style: StyleObject | any = {
  flexDirection: 'column',
  '@media screen and (min-width: 768px)': {
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
};
